export const professions = [
  {
    desc: [
      '2015年进入政府采购机票渠道，2018年取得服务商全国销售第五，广东省排名第一的成绩；2019年取得服务商全国销售第四，广东省排名第一的成绩。（信息来源于政府采购机票管理网站）',
    ],
    image: '/images/gp-service.png',
  },
  {
    desc: [
      '从2015年的零家合作客户，到2020年2112家固定合作客户，客户还在不断增长中……，每个月持续消费客户占比99%',
    ],
    image: '/images/gp-finance.png',
  },
  {
    desc: [
      '从第一张GP票成功出票，到今天日超1000张/天',
      '产品涉及到国内机票、国际机票、国内酒店、国际酒店、签证、用车、保险、甚至是礼仪培训……',
    ],
    image: '/images/gp-sales.png',
  },
]
